import { render, staticRenderFns } from "./AgentsTransactions.vue?vue&type=template&id=7a61a34a"
import script from "./AgentsTransactions.vue?vue&type=script&lang=js"
export * from "./AgentsTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports